import * as _ from 'lodash';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, DoBootstrap, Injector, ApplicationRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule }   from '@angular/forms';

import { RouterWrapperAppComponent } from './router-wrapper/components/app/app.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CustomElementsModule } from './custom-elements/custom-elements.module';
import { createCustomElement } from '@angular/elements';
import { EventModule } from './event/event.module';
import { VirtualEventModule } from './virtual-event/virtual-event.module';
import { CampaignModule } from './campaign/campaign.module';
import { ToastModule } from './toast/toast.module';
import { DialogModule } from './dialog/dialog.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { GuestInformationListModule } from './guest-information-list/guest-information-list.module';
import { CommonModule } from '@angular/common';
import { CoreModule } from './core/core.module';
import { IconModule } from './icon/icon.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SignupModule } from './signup/signup.module';
import { ChatModule } from './chat/chat.module';
import { ReportsModule } from './reports/reports.module';
import { DonorPageModule } from './donor-page/donor-page.module';
import { SponsorGroupModule } from './sponsor-group/sponsor-group.module';

import { DefaultValueAccessor } from '@angular/forms';
import { RouterWrapperModule } from './router-wrapper/router-wrapper.module';
import { EventPageModule } from './event-page/event-page.module';
import { FacebookModule } from './facebook/facebook.module';

const original = DefaultValueAccessor.prototype.registerOnChange;

DefaultValueAccessor.prototype.registerOnChange = function (fn) {
  return original.call(this, value => {
    const trimmed = _.isString(value) ? value.trim() : value;
    return fn(trimmed);
  })
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    RouterWrapperModule,
    CustomElementsModule,
    EventModule,
    ReportsModule,
    VirtualEventModule,
    CampaignModule,
    SignupModule,
    ToastModule,
    DialogModule,
    DashboardModule,
    GuestInformationListModule,
    CoreModule,
    IconModule,
    BrowserAnimationsModule,
    ChatModule,
    DonorPageModule,
    SponsorGroupModule,
    FacebookModule.forRoot(),
    EventPageModule
  ],
  providers: [],
  bootstrap: []
})
export class AppModule implements DoBootstrap {
  constructor(injector: Injector) {
  const AppElement = createCustomElement(AppComponent, {injector});

    try {
      customElements.define('paybee-app-element', AppElement);
    } catch(e) {}
  }
  ngDoBootstrap(app: ApplicationRef) {
    if(document.getElementById('app-router-wrapper-root')) {
      app.bootstrap(RouterWrapperAppComponent);
    }
  }
}
